import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GbGemeindeSearchMode } from 'app/shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { GbGemeindeComponent } from 'app/shared/widgets/gb-gemeinde/gb-gemeinde.component';
import { AmtlichebewertungNeskoService, NeskoAbStandardRequestMeta } from 'app/core/amtlichebewertung-api';
import { copy } from 'app/shared/functions/meta.functions';
import { Subscription } from 'rxjs';
import { FormsModule, NgForm } from '@angular/forms';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchStateService } from '../../shared/services/search-state.service';
import { AbstractSearchComponent } from '../../shared/components/abstract-component/abstract-search.component';
import { GbGemeindeId } from '../../core/av-api';
import { GwrGemeindeId } from '../../core/gwr-api';
import { ContentHeaderComponent } from '../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { MetaDirective } from '../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../shared/form-control/form-control.component';
import { GbGemeindeComponent as GbGemeindeComponent_1 } from '../../shared/widgets/gb-gemeinde/gb-gemeinde.component';
import { MetaDisablerDirective } from '../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-neskoab-suche',
  templateUrl: './neskoab-suche.component.html',
  styleUrls: ['./neskoab-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    GbGemeindeComponent_1,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class NeskoabSucheComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;
  onTouched: () => void;
  onValidatorChange: () => void;
  searchRequest: NeskoAbStandardRequestMeta;
  gbGemeindeSearchMode = GbGemeindeSearchMode.NESKOAB_REGISTER_SEARCH;
  @ViewChild(GbGemeindeComponent, { static: false })
  private gemeindeComponent: GbGemeindeComponent;
  private subscription = new Subscription();

  constructor(
    private neskoAbService: AmtlichebewertungNeskoService,
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(stateService);
    keysToTranslate<string>(['neskoabSearch.search.breadcrumb', 'neskoab.SucheTitel']);
  }

  ngOnInit() {
    this.subscription = this.neskoAbService.searchStandardTemplate().subscribe((template) => {
      this.searchRequest = this.copyLastRequest(template);
      this.setSearchValue(this.searchRequest.gbGemeindeId);
    });
  }

  public setSearchValue(id: GbGemeindeId | GwrGemeindeId) {
    this.gemeindeComponent.writeValue(id);
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.searchRequest;
    this.router.navigate(['detail'], {
      relativeTo: this.route,
      queryParams: {
        gemeindeId: this.searchRequest.gbGemeindeId.id,
        nummer: this.searchRequest.nummer,
        nummer2: this.searchRequest.nummer2,
        nummer3: this.searchRequest.nummer3
      }
    });
  }

  onReset() {
    this.form.reset();
    this.subscription = this.neskoAbService.searchStandardTemplate().subscribe((template) => {
      this.searchRequest = {
        ...copy(this.stateService.lastRequest, template),
        gbGemeindeId: { id: null }
      };
    });
    this.gemeindeComponent.focus();
  }

  emptyGemeindeSearch() {
    this.gemeindeComponent.onClear();
    this.searchRequest.gbGemeindeId = null;
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
